import { render, staticRenderFns } from "./ProductionOrdersNC.vue?vue&type=template&id=7dd35404&lang=pug"
import script from "./ProductionOrdersNC.vue?vue&type=script&lang=js"
export * from "./ProductionOrdersNC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports